export enum TooltipTypeEnum {
  positionTop = 'top',
  positionRight = 'end',
  positionBottom = 'bottom',
  positionLeft = 'start',
}
